import { render, staticRenderFns } from "./AuxiliaryApproval.vue?vue&type=template&id=7a5b0ce4&"
import script from "./AuxiliaryApproval.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryApproval.vue?vue&type=script&lang=js&"
import style0 from "./AuxiliaryApproval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports